var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTrailer(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 180,
    height: 120,
    viewBox: "0 0 180 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M133.924 75.741H140.683M140.683 75.741V73.5009M140.683 75.741H162.028V73.5009H160.271M140.683 73.5009L133.924 71.0574M140.683 73.5009H157.929M157.929 73.5009V70.4715H160.271V73.5009M157.929 73.5009H160.271",
    stroke: "black",
    strokeOpacity: 0.6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M63.6669 87.0004C67.9453 87.0004 71.4136 83.5321 71.4136 79.2537C71.4136 74.9753 67.9453 71.507 63.6669 71.507C59.3885 71.507 55.9202 74.9753 55.9202 79.2537C55.9202 83.5321 59.3885 87.0004 63.6669 87.0004Z",
    stroke: "black",
    strokeOpacity: 0.6
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M43.7608 87.0004C48.0392 87.0004 51.5075 83.5321 51.5075 79.2537C51.5075 74.9753 48.0392 71.507 43.7608 71.507C39.4824 71.507 36.0141 74.9753 36.0141 79.2537C36.0141 83.5321 39.4824 87.0004 43.7608 87.0004Z",
    stroke: "black",
    strokeOpacity: 0.6
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M33.2768 75.7401H23.8544V62.8593M23.8544 62.8593V33H27.9527V62.8593M23.8544 62.8593H27.9527M27.9527 62.8593H133.924V75.7401H74.8209",
    stroke: "black",
    strokeOpacity: 0.6
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8544 67.5429H133.924",
    stroke: "black",
    strokeOpacity: 0.6
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5124 67.5429L17.9995 70.7307V75.7392H21.5124",
    stroke: "black",
    strokeOpacity: 0.6
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M119.874 75.7392V83.9364M124.557 75.7392V83.9364",
    stroke: "black",
    strokeOpacity: 0.6
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M117.981 84.3871V87H126.449V84.3871H117.981Z",
    stroke: "black",
    strokeOpacity: 0.6
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrailer);
export default __webpack_public_path__ + "static/media/trailer.5467047bfea1c35526ea714953f89023.svg";
export { ForwardRef as ReactComponent };